import { useEffect, useState } from 'react';

import { DisplayStatus, DISPLAY_STATUS } from 'types/notification';
import { DisplayStatusBadgeView } from './DisplayStatusBadgeView';

type Props = {
  displayStatus: DisplayStatus;
};

export const DisplayStatusBadge: React.FC<Props> = ({ displayStatus }) => {
  const [label, setLabel] = useState<string>('');
  const [backgroundColor, setBackGroundColor] = useState<string>('');

  useEffect(() => {
    switch (displayStatus) {
      case DISPLAY_STATUS.TO_BE_DISPLAYED:
        setLabel('未表示');
        setBackGroundColor('rgba(38, 91, 169, 0.35)');
        break;
      case DISPLAY_STATUS.DISPLAYING:
        setLabel('表示中');
        setBackGroundColor('rgba(38, 91, 169, 1)');
        break;
      case DISPLAY_STATUS.END_OF_DISPLAY:
        setLabel('表示終了');
        setBackGroundColor('rgba(54, 55, 64, 0.35)');
        break;
      default:
    }
  }, [displayStatus]);

  return (
    <DisplayStatusBadgeView label={label} backgroundColor={backgroundColor} />
  );
};
